import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  // Prefer session-based token, fall back to persistent token
  const sessionToken: string | null = sessionStorage.getItem('token');
  const persistentToken: string | null = localStorage.getItem('token');
  const token: string | null = sessionToken || persistentToken;
  const subdomain: string | null = localStorage.getItem('serviceKey');
  const router = inject(Router);

  const appProtocol = window.location.protocol; // 'http:' or 'https:'

  // 1. Replace protocol in absolute URLs to match current page protocol
  // if (/^https?:\/\//i.test(req.url)) {
  //   const updatedUrl = req.url.replace(/^https?:/, appProtocol);
  //   req = req.clone({ url: updatedUrl });
  // }

  // 2. Add Authorization header unless it's a Google API
  if (token && !req.url.includes('googleapis')) {
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  // 3. Add Service-Code header unless it's a Google API
  if (subdomain && !req.url.includes('googleapis')) {
    req = req.clone({
      headers: req.headers.set('Service-Code', subdomain),
    });
  }
  // 4. Add Accept-Language header to inform backend about the selected language
  const lang = localStorage.getItem('lang');
  if (lang && !req.url.includes('googleapis')) {
    req = req.clone({
      headers: req.headers.set('X-Language', lang),
    });
  }

  // 5. Handle 401 Unauthorized
  return next(req).pipe(
    tap({
      error: (err) => {
        if (err.status === 401) {
          localStorage.clear();
          router.navigate(['auth/login']);
        }
      },
    }),
    catchError((err) => throwError(() => err)),
  );
};

